import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

import './App.css';
import HomePage from './pages/HomePage';
import LeadPage from './pages/LeadPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReportPage from './pages/ReportPage';
import LeadInfoPage from './pages/LeadInfoPage';
import MessageTemplateAddPage from './pages/MessageTemplateAddPage';
import MessageSendPage from './pages/MessageSendPage';
import ExportLeadPage from './pages/ExportLeadPage';


function App() {
  return (
    <div className="container" style={{ maxWidth: '100%' }}>
      <Router>
        <Switch>
          <Route path = "/leads" exact>
              <LeadPage />
          </Route>
          <Route path = "/leads/export">
            <ExportLeadPage />
          </Route>
          <Route path = "/lead/info/:leadId">
            <LeadInfoPage />
          </Route>
          <Route path = "/message/template/add">
            <MessageTemplateAddPage />
          </Route>
          <Route path = "/message/send">
            <MessageSendPage />
          </Route>
          <Route path = "/report">
            <ReportPage />
          </Route>
          <Route path = "/">
            <HomePage />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
